<template>

  <form novalidate v-if="isSelectionScreen">
    <fieldset>
      <div class="row">
        <div class="column">
          <label for="cellphone">
            ¿Cómo quieres solicitar tu código?
          </label>
        </div>
      </div>
      <div class="row row-responsive">
        <div class="column column-xs-100 column-sm-60">
          <span class="select no-margin">
            <select
              v-model.trim="$v.mediumSelection.cellPhoneVerification.$model">
              <option value="" disabled selected>Seleccione:</option>
              <option value="1">Enviando un SMS / Authy</option>
              <option value="2">Haciendo una llamada</option>
            </select>
            <span class="arrow"></span>
          </span>
          <p class="error" v-if="errors">
            <span
              v-if="!$v.mediumSelection.cellPhoneVerification.required">
              Debe seleccionar un medio para continuar.
            </span>
          </p>
        </div>
        <div class="column column-xs-100 column-sm-40">
          <button
            class="button float-right"
            @click.prevent="submitMFA()">Enviar código
          </button>
        </div>
      </div>
      <div class="row">
        <div class="column box-errors">
          <p
            class="error" v-if="errors">
            El formulario tiene errores,
            por favor revísalos antes de seguir.
          </p>
          <p class="error" v-else-if="empty">
            El formulario está vacío, todos los campos son obligatorios.
          </p>
        </div>
      </div>
    </fieldset>
  </form>
  <form novalidate v-else>
    <fieldset>
      <div class="row">
        <div class="column">
          <label
            for="code"
            :class="{'error-text': endpointErrors.token}">
            Ingrese el código proporcionado:
          </label>
        </div>
      </div>
      <div class="row row-responsive">
        <div class="column column-xs-100 column-sm-67">
          <input
            type="text"
            name="code"
            placeholder="1234567"
            v-model.trim="$v.codeInteraction.verificationCode.$model">
        </div>
        <div class="column column-xs-100 column-sm-33">
          <button
            class="button button-block"
            @click.prevent="submitToken()"
            :disabled="disableButton">Enviar
          </button>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <p class="error" v-if="errors">
            <span
              v-if="!$v.codeInteraction.verificationCode.required">
              El código es obligatorio.
            </span>
            <span
              v-if="!$v.codeInteraction.verificationCode.numeric">
              El código debe ser numérico.
            </span>
            <span
              v-if="!$v.codeInteraction.verificationCode.minLength">
              El código debe tener 7 números.
            </span>
            <span
              v-if="!$v.codeInteraction.verificationCode.maxLength">
              El código debe tener 7 números.
            </span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <p class="send-again">
            ¿No recibiste el código?
              <a href="#" @click.prevent="sendMFAToServer()">
                <b>Enviar de nuevo</b>
              </a>
              o seleccionar
              <a href="#"
                @click.prevent="changeMedium()">
                <b>método de validación</b>
              </a>
            </p>
        </div>
      </div>
      <div class="row">
        <div class="column box-errors">
          <p class="error" v-if="errors">
            El formulario tiene errores,
            por favor revísalos antes de seguir.
          </p>
          <p class="error" v-else-if="empty">
            El formulario está vacío, todos los campos son obligatorios.
          </p>
        </div>
      </div>
    </fieldset>
  </form>

</template>

<script>

import httpRequestMixin from '@/mixins/httpRequestMixin'

import { required, numeric, minLength, maxLength }
  from 'vuelidate/lib/validators'

export default {
  name: 'MFAHandler',
  validations: {
    mediumSelection: {
      cellPhoneVerification: { required }
    },
    codeInteraction: {
      verificationCode: {
        required,
        numeric,
        minLength: minLength(7),
        maxLength: maxLength(7)
      }
    }
  },
  mixins: [httpRequestMixin],
  props: { 'button': String },
  data () {
    return {
      errors: false,
      empty: false,
      isSelectionScreen: true,
      endpointErrors: {
        medium: false,
        token: false
      },
      mediumSelection: {
        cellPhoneVerification: ''
      },
      codeInteraction: {
        verificationCode: null
      },
      disableButton: false
    }
  },
  methods: {
    changeMedium: function () {
      this.isSelectionScreen = true
      this.codeInteraction.verificationCode = null
      this.mediumSelection.cellPhoneVerification = ''
    },
    submitMFA: function () {
      this.empty = !this.$v.mediumSelection.$anyDirty
      this.errors = this.$v.mediumSelection.$anyError

      if (this.errors === false && this.empty === false) {
        this.sendMFAToServer()
        this.disableButton = false
      }
    },
    submitToken: function () {
      this.empty = !this.$v.codeInteraction.$anyDirty
      this.errors = this.$v.codeInteraction.$anyError

      if (this.errors === false && this.empty === false) {
        this.$emit('tokenObtained', this.codeInteraction.verificationCode)

        this.codeInteraction.verificationCode = null
        this.mediumSelection.cellPhoneVerification = ''
        this.isSelectionScreen = true
        this.disableButton = this.button
      }
    },
    sendMFAToServer: async function () {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/mfa/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          medium: this.mediumSelection.cellPhoneVerification
        }
      }

      const response = await this.httpRequest(options)
      if (response && response.status === 201) {
        this.isSelectionScreen = false
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/MFAHandler.vue